import React, { useState } from 'react';
import KPICard from '../../components/shared/KPICard';
import StatusPill from '../../components/shared/StatusPill';
import SectionDivider from '../../components/shared/SectionDivider';
import { consumerTickets } from '../../data/mockData';
import { TicketStatus } from '../../types';
import { formatDate } from '../../utils/dateHelpers';

export default function ConsumerSupport() {
  const [issueType, setIssueType] = useState('Inverter / MPPT fault');
  const [priority, setPriority] = useState('Normal');
  const [description, setDescription] = useState('MPPT 2 output is 8% lower than MPPT 1. Possible soiling or partial shading on string 2. Request site inspection.');
  const [submitted, setSubmitted] = useState(false);

  const openCount = consumerTickets.filter(t => t.status === TicketStatus.OPEN).length;
  const resolvedCount = consumerTickets.filter(t => t.status === TicketStatus.RESOLVED || t.status === TicketStatus.CLOSED).length;

  return (
    <div className="p-6 space-y-6">
      {/* KPIs */}
      <div className="flex gap-4">
        <KPICard title="Open Tickets" value={openCount} bgColor="bg-orange-50" subtextColor="amber" subtext="Awaiting resolution" />
        <KPICard title="Resolved Tickets" value={resolvedCount} bgColor="bg-green-50" subtextColor="green" subtext="Last 90 days" />
        <KPICard title="Avg Resolution" value="1.8 days" subtext="Zebron Solar SLA: 3 days" />
        <KPICard title="Assigned Vendor" value="Zebron Solar" subtext="Primary service partner" />
      </div>

      <div className="flex gap-4">
        {/* Raise ticket form */}
        <div className="flex-1 bg-white rounded-card border border-border shadow-card p-4">
          <SectionDivider title="Raise Service Request" subtitle="For plant GJ-0482" />

          {submitted ? (
            <div className="bg-green-50 border border-green-200 rounded-input p-4 text-center">
              <p className="text-sm font-semibold text-consumer-green">Ticket raised successfully!</p>
              <p className="text-xs text-text-secondary mt-1">SMS confirmation sent to registered number.</p>
              <button onClick={() => setSubmitted(false)} className="mt-3 text-xs text-accent hover:underline">Raise another</button>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-xs text-text-secondary mb-1">Issue Type</label>
                <select
                  className="w-full text-xs border border-border rounded-input px-3 py-2 bg-white focus:outline-none focus:border-consumer-green"
                  value={issueType}
                  onChange={e => setIssueType(e.target.value)}
                >
                  <option>Inverter / MPPT fault</option>
                  <option>Communication / Datalogger issue</option>
                  <option>Panel cleaning request</option>
                  <option>Grid / Voltage issue</option>
                  <option>Billing / Net metering query</option>
                  <option>Other</option>
                </select>
              </div>
              <div>
                <label className="block text-xs text-text-secondary mb-1">Priority</label>
                <select
                  className="w-full text-xs border border-border rounded-input px-3 py-2 bg-white focus:outline-none focus:border-consumer-green"
                  value={priority}
                  onChange={e => setPriority(e.target.value)}
                >
                  <option>Low</option>
                  <option>Normal</option>
                  <option>High</option>
                  <option>Urgent</option>
                </select>
              </div>
              <div>
                <label className="block text-xs text-text-secondary mb-1">Description</label>
                <textarea
                  className="w-full text-xs border border-border rounded-input px-3 py-2 bg-white focus:outline-none focus:border-consumer-green resize-none"
                  rows={4}
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                />
              </div>
              <button
                onClick={() => setSubmitted(true)}
                className="w-full bg-consumer-green text-white text-xs font-semibold px-4 py-2.5 rounded-input hover:bg-consumer-green-light transition-colors"
              >
                Submit Ticket
              </button>
              <p className="text-xs text-text-tertiary text-center">
                Ticket will be assigned to Zebron Solar. SMS confirmation sent.
              </p>
            </div>
          )}
        </div>

        {/* Ticket history */}
        <div className="flex-1 bg-white rounded-card border border-border shadow-card p-4">
          <SectionDivider title="Ticket History" subtitle="Last 4 requests" />
          <div className="space-y-3">
            {consumerTickets.map(ticket => (
              <div key={ticket.id} className="border border-border rounded-input p-3 hover:bg-bg-secondary transition-colors cursor-pointer">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <p className="text-xs font-mono text-text-tertiary">{ticket.id}</p>
                    <p className="text-xs font-semibold text-text-primary mt-0.5 leading-tight">{ticket.issueType}</p>
                    <p className="text-xs text-text-tertiary mt-1">
                      Raised {formatDate(ticket.raisedDate)} · {ticket.assignedTo} · {ticket.assignedVendor}
                      {ticket.resolutionTime ? ` · Resolved in ${ticket.resolutionTime}` : ''}
                    </p>
                  </div>
                  <StatusPill
                    status={ticket.status === TicketStatus.OPEN ? 'open' : ticket.status === TicketStatus.IN_PROGRESS ? 'in_progress' : 'resolved'}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
